<template>
<v-container style="display:none;">
    <v-dialog v-model="display">
        <v-card>
        <v-card-title>SECURITY</v-card-title>
        <v-card-text>
            <ul>
                <li v-for="(item,index) in logs" :key="index">
                    {{item}}
                </li> 
            </ul>
        </v-card-text>
        </v-card>
    </v-dialog>
    
    <v-dialog v-model="aaulCheckupDisplay" max-width="500">
        <v-card class="pa-4"  >
            <v-card-title class="subtitle-1 justify-center" align="center">Performing aaul sanity checkup</v-card-title>
            <v-card-title class="justify-center"><v-progress-circular indeterminate size="20"></v-progress-circular></v-card-title>
        </v-card>
    </v-dialog>

    <v-dialog
      v-model="sessionExpired"
      max-width="500"
    >
      <v-card class="pa-4"  >
        <v-card-title style="display: block; font-size: 24px !important; word-break: inherit;" class="headline" align="center"><str index="message > session expired" /></v-card-title>
        <v-card-subtitle style="margin-bottom: 15px;" align="center"><str index="message > please refresh" /></v-card-subtitle>
        <v-card-subtitle style="margin-bottom: 15px;" align="center"><str index="message > unsaved work > load previous answers" /></v-card-subtitle>        
      </v-card>
    </v-dialog>

    <v-dialog
      v-model="setProfilePreferredLanguage"
      max-width="331"
    >
        <v-card>
            <v-card-title class="subtitle-1" style="word-break:keep-all">
                <div v-if="$store.getters.user">
                    <str index="message > align navigator_vivomap_language" />
                </div>
            </v-card-title>

            <v-card-actions class="justify-center">
                <v-btn
                    color="blue darken-1"
                    text
                    @click="()=>{ this.setProfilePreferredLanguage=false; }"
                >
                    <str index="button > no" />
                </v-btn>

                <v-btn
                    color="blue darken-1"
                    text
                    @click="()=>{this.mvc_user.updateUser(['language',this.$store.getters.language]);this.setProfilePreferredLanguage=false;}"
                >
                    <str index="button > yes" />
                </v-btn>

            </v-card-actions>
        </v-card>
    </v-dialog>
    
</v-container>
</template>

<script>
import languageCodes from '@/components/UI/languageCodes.js';

export default {
    name: "securityControl",
    mounted: function(){
        this.init();
    },
    data: function(){
        return {
            display: false,
            sessionExpired: false,
            setProfilePreferredLanguage: false,
            aaulCheckupDisplay: false,
            mvc_csrf: null,
            mvc_jwt: null,
            mvc_user: null,
            haveUserGroups: false,
            logs: [],
            languageCodes: languageCodes
        }
    },
    methods: {
        init: function(){
            var self = this;
            self.mvc_csrf = new this.csrf_controller(self);
            self.mvc_jwt = new this.jwt_controller(self);
            self.mvc_user = new this.user_controller(self);
            
            self.$controller.security = {
                csrf: self.mvc_csrf,
                jwt: self.mvc_jwt,
                user: self.mvc_user
            }

            // toggleService.send('TOGGLE');
            var init_csrf = self.$controller.security.csrf.init();
            init_csrf().then(function(response){
                self.customCLog('security > csrf init',response);
                self.mvc_session = new self.session_controller(self , {
                    max_session: 8*60*60, // 8h in seconds
                    max_idle: 2*60*60, // 2h in seconds
                });
                self.$controller.security.session = self.mvc_session;
                
                if (response.data.csrf.request !== undefined && response.data.csrf.request.result === true){
                    self.mvc_session.resetUserSession();
                    }
                if (response.data.csrf.validate !== undefined && response.data.csrf.validate.result === true){
                    setTimeout( function(){
                        if (self.user){
                            self.mvc_session.resetUserSession(response.data.csrf.validate);
                            self.mvc_session.startTracking(true);                        
                        }                        
                    }, 1000);
                }
                var init_jwt = self.$controller.security.jwt.init();
                init_jwt().then(function(){
                    // self.$controller.security.user.getGroups()
                },function(){
                    // console.log('JWT INIT: FAIL',response)
                })
            },function(){
                // console.log('CSRF INIT: FAIL')
            })
        },

        
        csrf_controller: function(self){
            var csrf = this;

            this.init = function(){
                var doThis = null;
                if(self.csrf){
                    doThis = csrf.model.validate;
                }else{
                    doThis = csrf.model.request;
                }

                return doThis;
            }

            this.model = new function(){
                this.request = function(){
                    self.logs.push('CSRF > request')
                    return new Promise((resolve,reject)=>{
                        self.$sendRequest({
                            action: 'csrf',
                            call: 'request'
                        }).then(function(response){
                            self.logs.push('CSRF > request: fail')
                            reject(response);
                        },function(response){
                            if(response.data.csrf.request.result===true){
                                self.$store.dispatch('csrf',response.data.csrf.request.token);
                                self.$store.dispatch('session_id',response.data.csrf.request.session_id);
                                self.logs.push('CSRF > request: pass');
                                self.logs.push('CSRF > request > session_id: '+self.$store.getters.session_id);
                                resolve(response);
                            }else{
                                self.logs.push('CSRF > request: fail');
                                self.$store.dispatch('clear_csrf');
                                reject(response);
                            }
                        })
                    });
                }

                this.validate = function(){
                    self.logs.push('CSRF > validate')
                    return new Promise((resolve,reject)=>{       
                        self.$store.dispatch('csrf',self.csrf);
                        self.$sendRequest({
                            action: 'csrf',
                            call: 'validate'
                        }).then(function(response){
                            if(response.data.csrf.validate.result===true){
                                self.$store.dispatch('session_id',response.data.csrf.validate.session_id);
                                self.logs.push('CSRF > validate: pass')
                                self.logs.push('CSRF > validate > session_id: '+self.$store.getters.session_id)
                                resolve(response);
                            }else{
                                self.logs.push('CSRF > validate: unexpected error')
                                reject(response);
                            }
                        },function(response){
                            self.$store.dispatch('clear_csrf');
                            self.logs.push('CSRF > validate: fail')
                            csrf.model.request().then(function(){
                                resolve(response)
                            },function(){
                                reject(response);
                            })
                        })
                    });
                }
            }
        },

        jwt_controller: function(self){
            var jwt = this;

            this.init = function(){
                var doThis = null;
                if(self.jwt){
                    self.$store.dispatch('jwt',self.jwt);
                    doThis = jwt.model.validate;
                }else{
                    doThis = function(){
                        return new Promise((resolve)=>{
                            resolve()
                        });                        
                    }
                }

                return doThis;
            }

            this.model = new function(){
                this.validate = function(){
                return new Promise((resolve,reject)=>{
                    self.logs.push('JWT > validate');
                    self.$sendRequest({
                        action: 'user',
                        call: 'validate'
                    }).then(function(response){
                        if(response.data.user.validate.result===true){
                            self.logs.push('JWT > validate: pass');
                            resolve(response);
                        }else{
                            self.$store.dispatch('clear_jwt');
                            self.logs.push('JWT > validate: fail');
                            reject(response);
                        }
                    })
                });                    
                }
            }
        },

        user_controller: function(self){
            var user = this;

            this.register = function(new_user, targetProgramId){
                if(targetProgramId){
                    self.$controller.program.campaignConversion(targetProgramId);
                }
                return user.model.register(new_user, targetProgramId);  
            }

            this.sendResetPasswordCode = function(email){
                return user.model.sendResetPasswordCode(email);
            }
            
            this.sendAccountValidationLink = function(email){
                return user.model.sendAccountValidationLink(email);
            }

            this.validateResetCode = function(email,code){
                return user.model.validateResetCode(email,code);
            }
            
            this.changePassword = function(email,password){
                return user.model.changePassword(email,password);
            }

            this.login = function(email,password){
                self.mvc_session.startTracking(false);
                return user.model.login(email,password);
            }

            this.validate_password = function(user_id, password) {
                return user.model.validate_password(user_id, password);
            }

            this.validate_email = function(user_email) {
                return user.model.validate_email(user_email);
            }

            this.logout = function(){
                self.mvc_session.resetLoggedTimer(); //stop tracking session duration
                if (self.$route.name !== 'home'){
                    self.$router.push('/');
                }
                user.model.logout().then(function(){
                    self.customCLog('clearing CSRF')
                    self.$store.dispatch('clear_csrf')                    
                    self.customCLog('Bye');
                    self.$controller.security.csrf.model.request();
                },function(){
                    self.customCLog('There was a problem - trying again');
                    user.logout();
                });                    
            }
            
            this.getGroups = function(){
                return new Promise((resolve, reject)=>{
                    user.model.getGroups().then(function(response){
                    if(response.data.user.getGroups){
                        resolve(response);
                    }else{
                        // self.haveUserGroups = false;
                        reject(response);
                    }
                    });
                });
            }  

            this.edit_user = function(user_package) {
                return user.model.editUser(user_package);
            }
            
            this.updateUser = function(attr_value_pair) {
                let user_package = { id: self.$store.getters.user.id };
                user_package[attr_value_pair[0]] = attr_value_pair[1];
                return this.edit_user(user_package);
            }

            this.model = new function(){

                this.register = function(new_user, targetProgramId){
                    return self.$sendRequest({
                        action: 'security',
                        call: 'register',
                        user: new_user,
                        targetProgramId: targetProgramId
                    })
                }

                this.sendResetPasswordCode = function(email){
                    return self.$sendRequest({
                        action: 'security',
                        call: 'sendResetPasswordCode',
                        email: email,
                        language: self.$language()
                    })
                }
                
                this.sendAccountValidationLink = function(email){
                    return self.$sendRequest({
                        action: 'security',
                        call: 'sendAccountValidationLink',
                        email: email
                    })
                }

                this.validateResetCode = function(email,code){
                    return self.$sendRequest({
                        action: 'security',
                        call: 'validateResetCode',
                        email: email,
                        code: code
                    })
                }
                
                this.changePassword = function(email,password){
                    return self.$sendRequest({
                        action: 'security',
                        call: 'changePassword',
                        email: email,
                        password: password,
                        language: self.$language()
                    })
                }

                this.login = function(email,password){
                    const showPreferredLanguageDialog = function(){
                        if(self.$store.getters.user.language !== self.$store.getters.language){
                            return true;
                        }
                        
                        return false;
                    }
                    
                    const parseJWT = function(token) {
                        var base64Url = token.split('.')[1];
                        var base64 = base64Url.replace(/-/g, '+').replace(/_/g, '/');
                        return JSON.parse(window.atob(base64));
                    }
                    
                    const restrictedEnv = ['qa', 'staging4', 'dev'];
                    const envGrantedProfileType = ['admin', 'staff', 'tester'];
                    
                    self.logs.push("USER > login");
                    return new Promise((resolve,reject)=>{
                        self.$sendRequest({
                            action: 'user',
                            call: 'login',
                            email: email,
                            password: password
                        }).then(function(response){
                            let results = response.data.user.login.results;
                            if(self.$allTrue(results)){                               
                                let jwt = response.data.user.login.jwt;
                                let token = parseJWT(jwt);
                                if (restrictedEnv.includes(self.$store.getters.environment) && !envGrantedProfileType.includes(token.user.type)){
                                    // perform envromental ACL sanity checkup
                                    self.aaulCheckupDisplay = true;
                                    self.$sendRequest({
                                        action: 'user',
                                        call: 'aaulCheckup',
                                        identity: email,
                                        environment: self.$store.getters.environment 
                                    }).then(function(aaulResponse){
                                        if (aaulResponse.data.user.aaulCheckup===true){
                                            self.$store.dispatch('jwt',jwt);
                                            self.logs.push("USER > login: pass");
                                            setTimeout(function(){
                                                self.aaulCheckupDisplay = false;
                                            }, 800);
                                            setTimeout( function(){
                                                self.setProfilePreferredLanguage = showPreferredLanguageDialog();
                                            }, 1000);
                                            return resolve(results);
                                        }
                                        else {
                                            reject(results);
                                            return window.location.href = "https://vivomap.ca";
                                        }
                                    });
                                }
                                else {
                                    self.$store.dispatch('jwt',jwt);
                                    self.logs.push("USER > login: pass");
                                    setTimeout( function(){
                                        self.setProfilePreferredLanguage = showPreferredLanguageDialog();
                                    }, 1000);
                                }
                                
                                resolve(results);
                            }else{
                                self.logs.push("USER > login: fail")
                                reject(results);
                            }           
                        })        
            
                    });
                }

                this.logout = function(){
                    return new Promise((resolve,reject)=>{
                        self.$sendRequest({
                        action: 'user',
                        call: 'logout'
                        }).then(function(response){
                        if(response.data.user && response.data.user.logout===true){
                            self.$store.dispatch('logout');                
                            resolve(response);
                        }else{
                            reject(response);
                        }              
                        })
                    })          
                }

                this.getGroups = function(){
                    return new Promise((resolve,reject)=>{
                        self.$sendRequest({
                            action: 'user',
                            call: 'getGroups'
                        }).then(function(response){
                        var groups = response.data.user.getGroups;
                            if(groups){
                                self.haveUserGroups = true;
                                for(let i in groups){
                                var group = groups[i];
                                group.name = JSON.parse(group.name);
                                group.programs = JSON.parse(group.programs);
                                }
                                var user = JSON.stringify(self.$store.getters.user);
                                user = JSON.parse(user);
                                user.groups = groups;
                                self.$store.dispatch('user',user);
                                resolve(response);
                            }else{
                                reject(response);
                            }        
                        })        
            
                    });
                }

                this.editUser = function(user_package) {
                    return new Promise((resolve, reject) => {
                        user_package.notes = self.$store.getters.user.notes;
                        if (self.firstMigratedUserLogin()){
                            //this will force users.updated attribute been updated to CURRENT_TIMESTAMP case profile submitted with no changes in details
                            user_package.notes = self.$store.getters.user.notes + " login-confirmed";
                        }
                        self.$sendRequest({
                            action: 'security',
                            call: 'editUser',
                            user: user_package
                        }).then(function(response) {
                            var results = response.data.security.editUser.result;
                            if(self.$allTrue(results)){
                                self.logs.push("USER > edit profile: success");
                                self.$store.dispatch('jwt', response.data.security.editUser.jwt);
                                resolve(results);
                            } else {
                                self.logs.push("USER > edit profile: fail");
                                reject(results);
                            }
                        });
                    });
                }

                this.validate_password = function(user_id, user_password) {
                    return new Promise((resolve, reject) => {
                        self.$sendBackgroundRequest({
                            action: 'security', 
                            call: 'validate_password',
                            user_id: user_id, 
                            user_password: user_password
                        }).then(function(response) {
                            var results = response.data.security['validate_password'].result;
                            resolve(results);
                        })
                    });
                }

                this.validate_email = function(user_email) {
                    return self.$sendRequest({
                        action: 'security',
                        call: 'validateEmail',
                        email: user_email
                    })
                }
                
            };            
        },

        session_controller: function(self, config){
            this.loggedTimer = null;
            this.sessionIncrement = 1; //session length tracking increment in secs
            this.timerInterval = 1000; //session tracking interval in miliseconds
            
            this.resetUserSession = function(details){ //initialize userSession obj values in store
                if (details === undefined){ // on login scenario
                    let timeCreated = Math.floor(Date.now() / 1000);
                    self.$store.dispatch('userSession',{loggedDuration: 0, lastActivity: Math.floor(Date.now() / 1000), created: timeCreated, updated: timeCreated});
                }
                else { //on awake from sleep scenario
                    self.$store.dispatch('userSession', {
                            loggedDuration: Math.floor(Date.now() / 1000) - details.updated, 
                            lastActivity: Math.floor(Date.now() / 1000), 
                            created: details.created, 
                            updated: details.updated
            });
                }
            }

            this.startTracking = function (skipDispatchReset){
                if (skipDispatchReset === false){  // this will happen in case of login
                    self.customCLog("Start/Reset Session Time Counter");
                    /*  Tracking started with Very First activity that user interacts with the application - essentially that would be loggin event/timestamp */
                    this.resetUserSession();
                    self.$store.dispatch('sessionLoggedTrackingStarted',Math.floor(Date.now() / 1000));
                }

                this.resetLoggedTimer();
                this.loggedTimer = setInterval( function (){
                        let deltaToStarted = Math.floor(Date.now() / 1000) - self.$store.getters.userSession.loggedTrackingStarted;

                        /* Check diff between session tracking lenght and session length since started. If diff. detected means that we have machine off(idle) period and apply adj. if needed */
                        let timeout = Math.round(deltaToStarted - self.$store.getters.sessionLoggedDuration);
                        let realSessionIncrement =  timeout > 2 ?  timeout : this.sessionIncrement;
                        let sessionLoggedDuration = self.$store.getters.sessionLoggedDuration + realSessionIncrement;
                        self.$store.dispatch('sessionLoggedDuration',sessionLoggedDuration);
                }.bind(this), this.timerInterval);
            }.bind(this);

            this.resetLoggedTimer = function() {
                clearInterval(this.loggedTimer);
                self.$store.dispatch('sessionLoggedDuration',0);
            }.bind(this);

            this.validateMaxSessionDuration = function (timeout) {
                if (timeout >= config.max_session){
                    self.sessionExpired = true; // popup v-dialog
                    self.mvc_user.logout();
                }
        
                let idleTimeout = Math.floor(Date.now() / 1000) - self.$store.getters.userSession.lastActivity;
                if (idleTimeout > config.max_idle){
                    self.sessionExpired = true; // popup v-dialog
                    self.mvc_user.logout();
                }
            }
      
            this.setSessionLastActivity = function(activityTimestamp){
                activityTimestamp = activityTimestamp !== undefined ? activityTimestamp : Math.floor(Date.now() / 1000);
                self.$store.dispatch('sessionLastActivity',activityTimestamp);
            }
        }
    },
    computed: {
        csrf: function(){
            return this.$store.getters.csrf ? this.$store.getters.csrf : this.$cookie.get('csrf') ? this.$cookie.get('csrf') : false;
        },
        jwt: function(){
            return this.$store.getters.jwt ? this.$store.getters.jwt : this.$cookie.get('jwt') ? this.$cookie.get('jwt') : false;
        },
        user: function(){
            return this.$store.getters.user;
        },
        sessionLoggedDuration: function(){
            return this.$store.getters.sessionLoggedDuration;
        }
    },
    watch: {
        user: function( after, before ){
            if(this.$store.getters.user && this.haveUserGroups===false){
                this.$controller.security.user.getGroups();
            }

            if(!this.user){
                this.haveUserGroups=false
            }
        },
        sessionLoggedDuration: function (after, before){
            if (after){
                this.mvc_session.validateMaxSessionDuration(after);
            }
        }
    }
}
</script>

<style>

</style>